import React, { useState, useEffect } from "react";
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import * as yup from "yup";
import { Form as FormUi, Container, Segment, Dropdown, Button, Radio, Icon, Checkbox } from "semantic-ui-react";
import { MyNormalCheckBox } from "../dynamicComponent/myInputs";
import CreatAxios from "../axiosComponent/create";
import UpdateAxios from "../axiosComponent/update";
import Axios from 'axios';
import {
  successAlertDispatcher,
  warningAlertDispatcher,
  errorAlertDispatcher,
  infoAlertDispatcher,
} from "../../redux/actions/alertAction";
import UploadFile from "../dynamicComponent/Upload";

import { connect } from "react-redux";
import { translate } from "react-i18next";
import { AllRegex, REQUIRED_MESSAGES } from "../../utils/validation";
import { INVALID_FIELDS, REQUIRED_FIELDS } from "../../utils/validationConstant";
import { LOCAL_STORAGE, FEATURES, getFieldLength } from "../../utils/constant";
import { MASTERS_MSG } from "../../utils/toastMsgConstant";
import BranchTable from "./branchTable";
import VendorVehicleTable from "./vehicleTable";
import AddUserTable from "../consignorComponent/addUserTable";
import moment from 'moment/moment';
import { YYYY_MM_DD } from "../../utils/constant";
import VendorPSLineGSTMappingTable from "./vendorPSLineGSTMappingTable";
import PreferredVehicleTypes from "./preferredVehicleTypes";
import PreferredLocation from "./preferredLocation";

const InsertVendor = ({ values, touched, errors, t, editData, usersList, action, setFieldValue }) => {
  const [vendorCategoryList, setVendorCategoryList] = useState([]);
  const [vendorPSLineGSTMappingData, setVendorPSLineGSTMappingData] = useState([]);

  const getItReturnUrlImage = (imageKey) => {
    const userId = LOCAL_STORAGE.userId;
    const token = LOCAL_STORAGE.userToken;
    const customerNo = LOCAL_STORAGE.customerNo;
    return `${process.env.REACT_APP_MASTER_API}/transporterMaster/getDocument?authorization=${token}&keyName=${imageKey}&customerNumber=${customerNo}&userId=${userId}`
  }

  const getFile = (imageKey) => {
    const userId = LOCAL_STORAGE.userId;
    const token = LOCAL_STORAGE.userToken;
    const customerNo = LOCAL_STORAGE.customerNo;
    const url = `${process.env.REACT_APP_MASTER_API}/transporterMaster/getDocument?authorization=${token}&keyName=${imageKey}&customerNumber=${customerNo}&userId=${userId}`
    window.open(url, '_blank').focus();
  }

  const isImageFile = (key) => {
    let image_ext = ["jpeg", "jpg", "png"]
    let key_arr = key && key.split(".")
    let key_ext = key_arr && key_arr.length && key_arr[key_arr.length - 1]
    if(key_ext && image_ext.includes(key_ext)) return true;
    else return false;
  }


  useEffect(() => {
    const userId = LOCAL_STORAGE.userId;
    const token = LOCAL_STORAGE.userToken;
    const customerNo = LOCAL_STORAGE.customerNo;
    console.log(action);
    Axios.get(`${process.env.REACT_APP_MASTER_API}/vendorType/0`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': token
      },
      params: {
        customerNo: customerNo,
        userId: userId
      }
    }).then((response => {
      let options = [];
      response.data.resultSet.map((object, index) => {
        let temp = {}
        temp.key = object.vendorTypeId
        temp.text = object.vendorType
        temp.value = object.vendorTypeId
        temp.id = object.vendorTypeId
        return options[index] = temp
      })
      setVendorCategoryList(options);
    }))
      .catch(error => {
        console.log(error)
      })
  }, []);

  useEffect(() => {
    if(editData?.transporterMasterId){
      const userId = LOCAL_STORAGE.userId;
      const token = LOCAL_STORAGE.userToken;
      const customerNo = LOCAL_STORAGE.customerNo;

      Axios.get(`${process.env.REACT_APP_MASTER_API}/vendorPSLineItemGSTMapping`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': token
        },
        params: {
          customerNo: customerNo,
          userId: userId,
          vendorId: editData.transporterMasterId
        }
      }).then((response => {
        if(response.data?.resultSet?.length > 0){
          setVendorPSLineGSTMappingData(response.data.resultSet)
        }
      }))
        .catch(error => {
          console.log(error)
        })
    }
  }, [editData])

  //Formik




  return (
    <React.Fragment>
      <Formiker>

        <Segment>
          <b>Basic Details</b>
          <div className="m-3 pl-3">
            <div className="ui form">
              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t(!FEATURES.usePartnerInsteadOfVendor ? "vendor_code.vendor_title" : "vendor_code.title") || "Vendor Code"}
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                error={
                  touched.transporterCode && errors.transporterCode
                    ? true
                    : false
                }
                >
                  <Fieldmik
                    type="text"
                    className="ui input"
                    disabled={editData.transporterCode ? true : false}
                    name="transporterCode"
                    placeholder={t("vendor_code.placeholder") || "Type Code"}
                  />
                  {touched.transporterCode && errors.transporterCode ? (
                    <div className="error-msg">
                      {errors.transporterCode}
                    </div>
                  ) : null}
                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t(!FEATURES.usePartnerInsteadOfVendor ? "vendor_name.vendor_title" : "vendor_name.title") || "Vendor Company Name"} <span className="red">*</span>{" "}
                  </label>
                </FormUi.Field>
                <FormUi.Field width={4} className="display-grid-center-imp"
                  error={
                    touched.transporterName && errors.transporterName
                      ? true
                      : false
                  }
                >
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="transporterName"
                    placeholder={t("vendor_name.placeholder") || "Type Name"}
                  />
                  {touched.transporterName && errors.transporterName ? (
                    <div className="error-msg">
                      {errors.transporterName}
                    </div>
                  ) : null}
                </FormUi.Field>
              </FormUi.Group>
              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("contact_person_name.title") || "Contact Person Name"}
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                  error={
                    touched.transporterContactPerson &&
                      errors.transporterContactPerson
                      ? true
                      : false
                  }
                >
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="transporterContactPerson"
                    placeholder={
                      t("contact_person_name.placeholder") ||
                      "Enter Contact Person Name"
                    }
                  />
                  {touched.transporterContactPerson &&
                    errors.transporterContactPerson ? (
                    <div className="error-msg">
                      {errors.transporterContactPerson}
                    </div>
                  ) : null}

                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {FEATURES.constactPersonNoRequiredInVendorMaster ? "Contact Person Number *" : t(`contact_person_number.title`) || "Contact Person Number"}
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                  error={
                    touched.transporterContactPersonNumber &&
                      errors.transporterContactPersonNumber
                      ? true
                      : false
                  }
                >
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="transporterContactPersonNumber"
                    placeholder={
                      t("contact_person_number.placeholder") ||
                      "Enter Contact Person Number"
                    }
                  />
                  {touched.transporterContactPersonNumber &&
                    errors.transporterContactPersonNumber ? (
                    <div className='error-msg'>
                      {errors.transporterContactPersonNumber}
                    </div>
                  ) : null}
                </FormUi.Field>
              </FormUi.Group>
              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t(!FEATURES.usePartnerInsteadOfVendor ? "company_address.vendor_title" : "company_address.title") || "Company Address"}
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                  error={
                    touched.companyAddress && errors.companyAddress ? true : false
                  }
                >
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="companyAddress"
                    placeholder={
                      t("company_address.placeholder") || "Enter Company Address"
                    }
                  />
                  {touched.companyAddress && errors.companyAddress ? (
                    <div className='error-msg'>
                      {errors.companyAddress}
                    </div>
                  ) : null}
                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t(`pincode.title`) || "Pincode"}
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                  error={
                    touched.companyPincode && errors.companyPincode ? true : false
                  }
                >
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="companyPincode"
                    placeholder={t("pincode.placeholder") || "Enter Pincode"}
                  />
                  {touched.companyPincode && errors.companyPincode ? (
                    <div className='error-msg'>
                      {errors.companyPincode}
                    </div>
                  ) : null}
                </FormUi.Field>
              </FormUi.Group>
              <FormUi.Group inline>

                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t(!FEATURES.usePartnerInsteadOfVendor ? 'user_vendor_email.title_alt' : "user_vendor_email.title") || "Email Id"}
                  </label>
                </FormUi.Field>
                <FormUi.Field width={4} className="display-grid-center-imp">
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="transporterEmail"
                    placeholder={t(!FEATURES.usePartnerInsteadOfVendor ? 'user_vendor_email.title_alt' : "user_vendor_email.title") || "Email Id"}
                  // error={touched.transporterEmail && errors.transporterEmail ? true : false}

                  />
                  {/* <Checkbox label={t("email_id.action.title") || "Alerts"} /> */}
                  {touched.transporterEmail && errors.transporterEmail ? (
                    <div className="error-msg">
                      {errors.transporterEmail}
                    </div>
                  ) : null}
                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>

                <FormUi.Field width={2}>
                  <label>{t(!FEATURES.usePartnerInsteadOfVendor ? "vendor_type.title_alt" : "vendor_type.title") || "Vendor Type"}</label>
                </FormUi.Field>
                <FormUi.Field width={4}>
                  <Dropdown
                    name="vendorTypeId"
                    clearable
                    style={{ width: "100%", fontWeight: "normal" }}
                    selection
                    placeholder={t("vendor_type.placeholder") || "Vendor Type"}
                    value={values.vendorTypeId}
                    options={vendorCategoryList}
                    onChange={(name, data) => {
                      setFieldValue("vendorTypeId", data.value);
                    }}
                  />
                </FormUi.Field>
              </FormUi.Group>

              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t(!FEATURES.usePartnerInsteadOfVendor ? 'transporter_mobile.title_vendor' : "transporter_mobile.title") || "Transporter Mobile No"}
                  </label>
                </FormUi.Field>
                <FormUi.Field width={4} className="display-grid-center-imp">
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="transporterMobile"
                    placeholder={t(!FEATURES.usePartnerInsteadOfVendor ? 'transporter_mobile.placeholder_vendor' : "transporter_mobile.placeholder") || "Email Id"}
                  />
                  {touched.transporterMobile && errors.transporterMobile ? (
                    <div className="error-msg">
                      {errors.transporterMobile}
                    </div>
                  ) : null}
                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>

                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("company_city.title") || "Company City"}
                  </label>
                </FormUi.Field>
                <FormUi.Field width={4} className="display-grid-center-imp">
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="companyCity"
                    placeholder={t("company_city.placeholder") || "Enter City Name"}
                  />
                  {touched.companyCity && errors.companyCity ? (
                    <div className="error-msg">
                      {errors.companyCity}
                    </div>
                  ) : null}
                </FormUi.Field>
              </FormUi.Group>


              {FEATURES.canAddRadarAndSpeedUserKeysInVendorMaster &&
                <FormUi.Group inline>
                  <FormUi.Field width={2}>
                    <label className="labelName">
                      {t("user_vendor_speed_key.title") || "GPS Tracking Token"}
                    </label>
                  </FormUi.Field>
                  <FormUi.Field width={4}>
                    <Fieldmik
                      type="text"
                      className="ui input"
                      name="speedKey"
                      placeholder={t("user_vendor_speed_key.placeholder") || "Enter Token"}
                    />
                  </FormUi.Field>
                  <FormUi.Field width={2}></FormUi.Field>

                  <FormUi.Field width={2}>
                    <label className="labelName">
                      {t("user_vendor_radar_key.title") || "SIM Tracking Token"}
                    </label>
                  </FormUi.Field>
                  <FormUi.Field width={4}>
                    <Fieldmik
                      type="text"
                      className="ui input"
                      name="radarKey"
                      placeholder={t("user_vendor_radar_key.placeholder") || "Enter Token"}
                    />
                  </FormUi.Field>
                </FormUi.Group>}

              <FormUi.Group inline>
                <FormUi.Field width={6}>
                  <Fieldmik className="mt-4" component={MyNormalCheckBox} checked={values.vendorOwnershipType}
                    label={t(!FEATURES.usePartnerInsteadOfVendor ? "self_vendor.vendor_title" : "self_vendor.title") || "Is Self Vendor"} name="vendorOwnershipType" />
                </FormUi.Field>
                <FormUi.Field width={2} />
                <FormUi.Field width={6}>
                  <Fieldmik className="mt-4" component={MyNormalCheckBox} checked={values.isPTL}
                    label={t(!FEATURES.usePartnerInsteadOfVendor ? "ptl_vendor.vendor_title" : "ptl_vendor.title") || "Is PTL Vendor"} name="isPTL" />
                </FormUi.Field>
              </FormUi.Group>
            </div>
          </div>
          <b>Financial Details</b>
          <div className="m-3 pl-3">
            <div className="ui form">
              <FormUi.Group inline>

                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("pan_no.title") || "Pan No."}
                  </label>
                </FormUi.Field>
                <FormUi.Field width={4} className="display-grid-center-imp">
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="companyPan"
                    placeholder={t("pan_no.placeholder") || "Pan No."}
                  />
                  {touched.companyPan && errors.companyPan ? (
                    <div className='error-msg'>
                      {errors.companyPan}
                    </div>
                  ) : null}
                  {/* <Checkbox label={t("gst_no.action.na") || "N/A"} /> */}
                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("pan_doc.title") || "Pan Document."}
                  </label>
                </FormUi.Field>
                <FormUi.Field width={4}>
                  <Fieldmik
                    name="panCardPath"
                    style={{ width: "23%" }}
                    buttonName={
                      values.panCardPath
                        ? "File Selected"
                        : "Choose File"
                    }
                    className="w3-button w3-round w3-small w3-border w3-hover-blue"
                    typer={["pdf", "jpeg", "jpg", "png"]}
                    values={values}
                    component={UploadFile}
                  />
                  {
                        values?.panCardPath && isImageFile(values?.panCardPath) ?
                        <a href={getItReturnUrlImage(values?.panCardPath)} target="_blank">
                              <img src={getItReturnUrlImage(values?.panCardPath)} style={{ height: 60, width: 60 }} />
                        </a>
                          :
                          <Button
                            onClick={() => getFile(values?.panCardPath)}
                            basic
                            size="mini"
                            type="button"
                            icon
                          >
                            <Icon name="eye" color="blue" />
                          </Button>
                      }
                </FormUi.Field>
              </FormUi.Group>

              <FormUi.Group inline>
                <FormUi.Field
                  width={6}
                >

                  <Checkbox label="Is TDS Exempted" className='mt-2' name='financialType' value='financialType'
                    checked={values.isTDSExempted === true || values.isTDSExempted == 1} onChange={() => {
                      setFieldValue("isTDSExempted", !values.isTDSExempted)
                    }} />
                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>

                <FormUi.Field
                  width={6}
                >

                  <Checkbox label="IT Returns" className='mt-2' name='financialType' value='financialType'
                    checked={values.isITReturnsFiled === true || values.isITReturnsFiled == 1} onChange={() => {
                      setFieldValue("isITReturnsFiled", !values.isITReturnsFiled)
                    }} />
                </FormUi.Field>
              </FormUi.Group>
              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  {
                    values.isTDSExempted == true ?
                      <label className="labelName">
                        {"TDS Exemption Certificate"}
                      </label> : null
                  }

                </FormUi.Field>
                <FormUi.Field width={4}>
                  {
                    values.isTDSExempted == true && <>
                      <Fieldmik
                        name="tdsExemptionCertificatePath"
                        style={{ width: "23%" }}
                        buttonName={
                          values.tdsExemptionCertificatePath
                            ? "File Selected"
                            : "Choose File"
                        }
                        className="w3-button w3-round w3-small w3-border w3-hover-blue"
                        typer={["pdf", "jpeg", "jpg", "png"]}
                        values={values}
                        component={UploadFile}
                      />

                      {touched.tdsExemptionCertificatePath && errors.tdsExemptionCertificatePath ? (
                        <div style={{ color: 'red', fontSize: '10px' }}>
                          TDS Exemption Certificate is required
                        </div>
                      ) : null}
                      {
                        values?.tdsExemptionCertificatePath.includes('pdf') ?
                          <Button
                            onClick={() => getFile(values?.tdsExemptionCertificatePath)}
                            basic
                            size="mini"
                            type="button"
                            icon
                          >
                            <Icon name="eye" color="blue" />
                          </Button>

                          : values?.tdsExemptionCertificatePath ?
                            <a href={getItReturnUrlImage(values?.tdsExemptionCertificatePath)} target="_blank">
                              <img src={getItReturnUrlImage(values?.tdsExemptionCertificatePath)} style={{ height: 60, width: 60 }} />
                            </a>
                            : null
                      }
                    </>
                  }

                </FormUi.Field>

                <FormUi.Field width={2}></FormUi.Field>

                <FormUi.Field width={2}>
                  {
                    values.isITReturnsFiled == true &&
                    <label className="labelName">
                      {"IT Returns File Path"}
                    </label>
                  }
                </FormUi.Field>
                <FormUi.Field width={4}>
                  {
                    values.isITReturnsFiled == true && <>
                      <Fieldmik
                        name="itReturnsFilePath"
                        style={{ width: "23%" }}
                        buttonName={
                          values.itReturnsFilePath
                            ? "File Selected"
                            : "Choose File"
                        }
                        className="w3-button w3-round w3-small w3-border w3-hover-blue"
                        typer={["pdf", "jpeg", "jpg", "png"]}
                        values={values}
                        component={UploadFile}
                      />
                      {
                        values?.itReturnsFilePath.includes('pdf') ?
                          <Button
                            onClick={() => getFile(values?.itReturnsFilePath)}
                            basic
                            size="mini"
                            type="button"
                            icon
                          >
                            <Icon name="eye" color="blue" />
                          </Button>
                          : values?.itReturnsFilePath ? <a href={getItReturnUrlImage(values?.itReturnsFilePath)} target="_blank"><img src={getItReturnUrlImage(values?.itReturnsFilePath)} style={{ height: 60, width: 60 }} /></a>
                            : null
                      }

                      {touched.itReturnsFilePath && errors.itReturnsFilePath ? (
                        <div style={{ color: 'red', fontSize: '10px' }}>
                          IT Returns File Path is required
                        </div>
                      ) : null}
                    </>
                  }
                </FormUi.Field>
              </FormUi.Group>


              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  {
                    values.isTDSExempted == true &&
                    <label className="labelName">
                      {"TDS Exemption Financial Year Start Date"}
                    </label>
                  }
                </FormUi.Field>
                <FormUi.Field width={4} className='form-block'>
                  {
                    values.isTDSExempted == true && <>
                      <Fieldmik
                        type="date"
                        className="ui input"
                        name="tdsExemptionFinancialYearStartDate"
                        placeholder={"TDS Exemption Financial Year Start Date"}
                        onChange={(e) => {
                          let date = moment(e.target.value).set('month', 3).set('date', 1).format(YYYY_MM_DD);
                          setFieldValue("tdsExemptionFinancialYearStartDate", date);
                          setFieldValue("tdsExemptionFinancialYearEndDate", moment(date).add(1, "year").subtract(1, 'day').format(YYYY_MM_DD));
                        }}

                        max={`${getCurrentFinancialYear().startYear}-04-01`}
                      />

                      {touched.tdsExemptionFinancialYearStartDate && errors.tdsExemptionFinancialYearStartDate ? (
                        <div style={{ color: 'red', fontSize: '10px' }}>
                          TDS Exemption Financial Year Start Date is required
                        </div>
                      ) : null}
                    </>}
                </FormUi.Field>

                <FormUi.Field width={2}></FormUi.Field>

                <FormUi.Field width={2}>
                  {
                    values.isITReturnsFiled == true && <>
                      <label className="labelName">
                        {"IT Returns Financial Year Start Date"}
                      </label>
                    </>}
                </FormUi.Field>
                <FormUi.Field width={4} className='form-block'>
                  {
                    values.isITReturnsFiled == true && <>
                      <Fieldmik
                        type="date"
                        className="ui input"
                        name="itReturnsFinancialYearStartDate"
                        placeholder={"IT Returns Financial Year Start Date"}
                        onChange={(e) => {
                          let date = moment(e.target.value).set('month', 3).set('date', 1).format(YYYY_MM_DD);
                          setFieldValue("itReturnsFinancialYearStartDate", date);
                          setFieldValue("itReturnsFinancialYearEndDate", moment(date).add(1, 'years').subtract(1, 'days').format(YYYY_MM_DD));
                        }}
                        max={`${getCurrentFinancialYear().startYear}-04-01`}
                      />
                      <br />
                      {touched.itReturnsFinancialYearStartDate && errors.itReturnsFinancialYearStartDate ? (
                        <div style={{ color: 'red', fontSize: '10px' }}>
                          IT Returns Financial Year Start Date is required
                        </div>
                      ) : null}
                    </>}
                </FormUi.Field>
              </FormUi.Group>

              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  {
                    values.isTDSExempted == true && <>
                      <label className="labelName">
                        {"TDS Exemption Financial Year End Date"}
                      </label>
                    </>}
                </FormUi.Field>
                <FormUi.Field width={4}>
                  {
                    values.isTDSExempted == true && <>
                      <Fieldmik
                        type="date"
                        className="ui input"
                        name="tdsExemptionFinancialYearEndDate"
                        placeholder={"TDS Exemption Financial Year End Date"}
                        disabled={true}
                      />

                      <br />
                      {touched.tdsExemptionFinancialYearEndDate && errors.tdsExemptionFinancialYearEndDate ? (
                        <div style={{ color: 'red', fontSize: '10px' }}>
                          TDS Exemption Financial Year End Date is required
                        </div>
                      ) : null}
                    </>}
                </FormUi.Field>

                <FormUi.Field width={2}></FormUi.Field>

                <FormUi.Field width={2}>
                  {
                    values.isITReturnsFiled == true && <>
                      <label className="labelName">
                        {"IT Returns Financial Year End Date"}
                      </label>
                    </>}
                </FormUi.Field>
                <FormUi.Field width={4}>
                  {
                    values.isITReturnsFiled == true && <>
                      <Fieldmik
                        type="date"
                        className="ui input"
                        name="itReturnsFinancialYearEndDate"
                        placeholder={"IT Returns Financial Year End Date"}
                        disabled={true}
                      />
                      {touched.itReturnsFinancialYearEndDate && errors.itReturnsFinancialYearEndDate ? (
                        <div style={{ color: 'red', fontSize: '10px' }}>
                          IT Returns Financial Year End Date is required
                        </div>
                      ) : null}
                    </>}
                </FormUi.Field>
              </FormUi.Group>

            </div>
          </div>
        </Segment>

        {(editData && !editData.transporterMasterId) ? (
          <Segment>
            <div>
              <h6>{t(!FEATURES.usePartnerInsteadOfVendor ? "vendor_note" : "note") || "Note - Branch, user and vehicle can be added while editing vendor"}</h6>
            </div>
          </Segment>
        ) : (
          null
        )}

        <Container className="p-3" textAlign="center">
          <button
            className="w3-button w3-blue w3-hover-blue w3-round w3-small"
            type="submit"
          >
            {t("action_button.submit") || "Submit"}
          </button>
        </Container>
        {(editData && !editData.transporterMasterId) ? (
          null
        ) : (
          <Segment>
            <BranchTable
              vendorId={editData.transporterMasterId}
              vendor_code={editData.transporterCode}
              BranchList={editData.branches}
              fileName="vendorBranch"
              importBaseUrl="vendorBranch"
              masterIdName={"vendorId"}
              masterIdValue={editData.transporterMasterId}
            />
          </Segment>
        )}
        {(editData && !editData.transporterMasterId) ? (
          null
        ) : (
          <Segment>
            <VendorPSLineGSTMappingTable
              vendorId={editData.transporterMasterId}
              vendor_code={editData.transporterCode}
              vendorPSLineGSTMappingData={vendorPSLineGSTMappingData}
            />
          </Segment>
        )}

        {(editData && !editData.transporterMasterId) ? (
          null
        ) : (
          <Segment>
            <VendorVehicleTable
              vendorId={editData.transporterMasterId}
              vendor_code={editData.transporterCode}
              vehicleList={editData.vehicles}
            />
          </Segment>
        )}
        {(editData && !editData.transporterMasterId) ? (
          null
        ) : (
          <>
          <Segment>
          <AddUserTable mainId={editData.transporterMasterId} modalType="vendor" usersItems={editData.users} whatsappConsentField={true} />
          </Segment>

          {FEATURES.enabledPreferredLocationAndVehicleType &&
          <>
            <Segment>
            <PreferredVehicleTypes
              vendorId={editData.transporterMasterId}
            />
          </Segment>

          <Segment>
            <PreferredLocation
              vendorId={editData.transporterMasterId}
            />
          </Segment>
          </>
          }
          </>
        )}
      </Formiker>
    </React.Fragment>
  )
};

const getCurrentFinancialYear = () => {
  let currentYear = new Date().getFullYear()
  let currentMonth = new Date().getMonth()
  let fromYear = currentMonth < 4 ? currentYear - 1 : currentYear
  let toYear = fromYear + 1

  return {
    startYear: fromYear,
    endYear: toYear
  }
}

const FormikAddVendor = withFormik({
  validationSchema: yup.object({
    transporterCode: yup.string().optional().max(getFieldLength("vendorCode") || 15,INVALID_FIELDS.INVALID_MAXIMUMSIZE(getFieldLength("vendorCode") || 15)),
    transporterName: yup.string().required(REQUIRED_FIELDS.REQUIRED).matches(AllRegex.Name, INVALID_FIELDS.INVALID_NAME),
    transporterContactPerson: yup.string().optional().matches(AllRegex.Name, INVALID_FIELDS.INVALID_NAME),
    transporterContactPersonNumber: FEATURES.constactPersonNoRequiredInVendorMaster ? yup.string().required("required").matches(AllRegex.MobileNumber, INVALID_FIELDS.INVALID_MOBILE_NO)
      : yup.string().optional().matches(AllRegex.MobileNumber, INVALID_FIELDS.INVALID_MOBILE_NO),
    companyPan: yup.string().optional().matches(AllRegex.PANIN, INVALID_FIELDS.INVALID_PAN_NUMBER),
    transporterEmail: yup.string().email(INVALID_FIELDS.INVALID_EMAIL).optional().matches(AllRegex.Email, INVALID_FIELDS.INVALID_EMAIL),
    vendorTypeId: yup.mixed().optional(),
    companyPincode: yup.string().matches(AllRegex.Pincode, INVALID_FIELDS.INVALID_PINCODE).optional().nullable(),
    companyAddress: yup.string().matches(AllRegex.Address, INVALID_FIELDS.INVALID_ADDRESS).optional().nullable(),
    speedKey: yup.string().optional(),
    radarKey: yup.string().optional(),
    transporterMobile: yup.string().optional().matches(AllRegex.MobileNumber, INVALID_FIELDS.INVALID_MOBILE_NO),
    companyCity: yup.string().optional(),
    isTDSExempted: yup.boolean().optional(),
    tdsExemptionCertificatePath: yup.string().optional().nullable()
      .when("isTDSExempted", (isTDSExempted) =>
        isTDSExempted ? yup.string().optional().required() : yup.string().optional().nullable()
      ),
    tdsExemptionFinancialYearStartDate: yup.string().optional().nullable()
      .when("isTDSExempted", (isTDSExempted) =>
        isTDSExempted ? yup.date().optional().required(REQUIRED_MESSAGES.FIELD_IS_REQUIRED).max(new Date(`${getCurrentFinancialYear().startYear}-04-01`)) : yup.date().optional().nullable()
      ),
    tdsExemptionFinancialYearEndDate: yup.string().optional().nullable()
      .when("isTDSExempted", (isTDSExempted) =>
        isTDSExempted ? yup.string().optional().required() : yup.string().optional().nullable()
      ),
    isITReturnsFiled: yup.boolean().optional(),
    itReturnsFilePath: yup.string().optional().nullable()
      .when("isITReturnsFiled", (isITReturnsFiled) =>
        isITReturnsFiled ? yup.string().optional().required() : yup.string().optional().nullable()
      ),
    itReturnsFinancialYearStartDate: yup.string().optional().nullable()
      .when("isITReturnsFiled", (isITReturnsFiled) =>
        isITReturnsFiled ? yup.date().optional().required(REQUIRED_MESSAGES.FIELD_IS_REQUIRED).max(new Date(`${getCurrentFinancialYear().startYear}-04-01`)) : yup.date().optional().nullable()
      ),
    itReturnsFinancialYearEndDate: yup.string().optional().nullable()
      .when("isITReturnsFiled", (isITReturnsFiled) =>
        isITReturnsFiled ? yup.string().optional().required() : yup.string().optional().nullable()
      ),
  }),
  enableReinitialize: true,
  mapPropsToValues: (props) => ({
    transporterCode: props?.editData?.transporterCode || "",
    transporterName: props?.editData?.transporterName || "",
    transporterContactPerson: props?.editData?.transporterContactPerson || "",
    transporterContactPersonNumber: props?.editData?.transporterContactPersonNumber || "",
    vendorOwnershipType: props?.editData?.vendorOwnershipType == '1' ? true : false,
    companyAddress: props?.editData?.companyAddress || "",
    companyPincode: props?.editData?.companyPincode || "",
    companyPan: props?.editData?.companyPan || "",
    transporterEmail: props?.editData?.transporterEmail || "",
    vendorTypeId: props?.editData?.vendorTypeId || null,
    existingVendorType: props?.editData?.vendorTypeId || null,
    speedKey: props?.editData?.speedKey || '',
    radarKey: props?.editData?.radarKey || '',
    transporterMobile: props?.editData?.transporterMobile || '',
    companyCity: props?.editData?.companyCity || '',
    isTDSExempted: props?.editData?.isTDSExempted ? '1' : '0',
    isITReturnsFiled: props?.editData?.isITReturnsFiled ? '1' : '0',
    tdsExemptionCertificatePath: props?.editData?.tdsExemptionCertificatePath || '',
    itReturnsFilePath: props?.editData?.itReturnsFilePath || '',
    tdsExemptionFinancialYearStartDate: props?.editData?.tdsExemptionFinancialYearStartDate || `${getCurrentFinancialYear().startYear}-04-01`,
    tdsExemptionFinancialYearEndDate: props?.editData?.tdsExemptionFinancialYearEndDate || `${getCurrentFinancialYear().endYear}-03-31`,
    itReturnsFinancialYearStartDate: props?.editData?.itReturnsFinancialYearStartDate || `${getCurrentFinancialYear().startYear}-04-01`,
    itReturnsFinancialYearEndDate: props?.editData?.itReturnsFinancialYearEndDate || `${getCurrentFinancialYear().endYear}-03-31`,
    isPTL : props?.editData?.isPTL && props?.editData?.isPTL == 1 ? true : false,
    panCardPath : props?.editData?.panCardPath || ''
  }),
  async handleSubmit(values, { props }) {
    const combine = {
      ...values,
      vendorTypeId: values.existingVendorType !== '' && values.vendorTypeId === '' ? ' ' : values.vendorTypeId,
      vendorOwnershipType: values.vendorOwnershipType === true ? '1' : '0',
      isPTL : values.isPTL ? "1" : "0"
    }
    if (props.editData.transporterMasterId) {

      await UpdateAxios({
        url: "transporterMaster",
        payload: { ...combine },
        uniqueId: props.editData.transporterMasterId,
      })
        .then((res) => {
          let alert = {
            type: "success",
            messageHeader: "Success",
            messageBody: MASTERS_MSG.VENDOR.UPDATE_SUCCESS,
          };
          props.successAlertDispatcher(alert);
          props.onFormSubmit();
        })
        .catch((err) => {
          let alert = {
            type: "error",
            messageHeader: "Error",
            messageBody: MASTERS_MSG.VENDOR.UPDATE_ERROR,
          };
          console.log(err);
          props.errorAlertDispatcher(alert);
        });
    } else {
      await CreatAxios({
        url: "transporterMaster",
        payload: { ...combine },
      })
        .then((res) => {
          let alert;
          if (res?.data?.status == 204 || res?.status == 204) {
            alert = {
              type: "warning",
              messageHeader: "Warning",
              messageBody: res?.data?.message ? res.data.message : MASTERS_MSG.VENDOR.CREATE_SUCCESS,
            };
            props.successAlertDispatcher(alert);
          } else {
            alert = {
              type: "success",
              messageHeader: "Success",
              messageBody: res?.data?.message ? res.data.message : MASTERS_MSG.VENDOR.CREATE_SUCCESS,
            };
            props.successAlertDispatcher(alert);
            props.onFormSubmit();
          }
        })
        .catch((err) => {
          let alert = {
            type: "error",
            messageHeader: "Error",
            messageBody: MASTERS_MSG.VENDOR.CREATE_ERROR,
          };
          props.errorAlertDispatcher(alert);
        });
    }
  },
})(InsertVendor);

export default connect(null, {
  successAlertDispatcher,
  warningAlertDispatcher,
  errorAlertDispatcher,
  infoAlertDispatcher,
})(translate("create_vendor")(FormikAddVendor));
